import TournamentStandingsComponent from "../../components/TournamentStandingsComponent";
import PrivateLayout from "../../layouts/PrivateLayout";
import { useParams } from "react-router-dom";

function TournamentStandings() {
  const backgroundImage = "/ww-wallpaper.webp";
  const { id } = useParams();

  return (
    <PrivateLayout backgroundImage={backgroundImage}>
      <TournamentStandingsComponent id={id} />
    </PrivateLayout>
  );
}

export default TournamentStandings;
